// Academy + Forge ticker resolution + Custom legs API helpers
import axios from "axios";
import { API } from "./api";

const client = axios.create({ baseURL: API, timeout: 30000, withCredentials: true });

// --- Forge extras ---
export const fetchForgeTickers = () =>
  client.get(`/forge/tickers`).then((r) => r.data);

export const resolveForgeTicker = (symbol) =>
  client.get(`/forge/resolve`, { params: { symbol } }).then((r) => r.data);

export const buildCustomStrategy = (payload) =>
  client.post(`/forge/build-custom`, payload).then((r) => r.data);

// --- Academy ---
export const fetchSofr = () => client.get(`/academy/sofr`).then((r) => r.data);

export const computeArbitrage = (payload) =>
  client.post(`/academy/arbitrage`, payload).then((r) => r.data);

export const fetchArbitrageMixSuggest = (target_yield = 0.10, margin = 0.02) =>
  client
    .get(`/academy/mix-suggest`, { params: { target_yield, margin } })
    .then((r) => r.data);
